<template>
  <div class="web-footer"  style="position:fixed;bottom: 0;left: 0 ">
    <div class="web-bottom ">
      <ul>
        <li>
          <router-link to="/index" style="margin-right: 12px">首页</router-link>|
        </li>
        <li>
        </li>
        <li>
          <router-link to="/privacy" style="margin-right: 12px">隐私政策</router-link>|
        </li>
        <li>
          <router-link to="/terms">用户服务协议</router-link>
        </li>
      </ul>
      <div class="copy">
        <div>
          SUNNYRIDE HOLDINGS LIMITED.All rights reserved.
        </div>
      </div>

    </div>

  </div>
</template>

<script>

  export default {
    name: "yw_footer",
    data() {
      return {
        localUrl: window.location.href,
        recordNum: 17025202, //备案号
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/yw_footer.vue